import axios from 'axios';


export const setAccessToken = (accessToken: string, refreshToken: string, keepLoggedIn: boolean) => {
  axios.defaults.headers.common.Authorization = 'Bearer ' + accessToken;
 
  sessionStorage.setItem('accessToken', accessToken);
  sessionStorage.setItem('refreshToken', refreshToken);
  if (keepLoggedIn) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
  }
};

// Sesija kartice ima prednost pred trajnom pohranom. `localStorage` dijele sve kartice, pa bi
// inače preuzeta sesija (koja živi samo u svojoj kartici) pročitala token djelatnika.
export const getAccessToken = (): string | null => {
  return (
    sessionStorage.getItem('accessToken') || localStorage.getItem('accessToken')
  );
};
export const getRefreshToken = (): string | null => {
  return (
    sessionStorage.getItem('refreshToken') || localStorage.getItem('refreshToken')
  );
};

export const clearAccessToken = () => {
  axios.defaults.headers.common.Authorization = null;
  sessionStorage.removeItem('accessToken');
  localStorage.removeItem('accessToken');
  sessionStorage.removeItem('refreshToken');
  localStorage.removeItem('refreshToken');

};

/**
 * Briše samo sesiju ove kartice. Za izlaz iz preuzete sesije: trajna prijava djelatnika u
 * `localStorage` nije njezina i mora ostati.
 */
export const clearSessionAccessToken = () => {
  axios.defaults.headers.common.Authorization = null;
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('refreshToken');
};
